module.exports = __webpack_public_path__ + "ad7842b0d69bb1c1478a4b9795fd63b5.png";